import { render, staticRenderFns } from "./AssessmentAndPlan.vue?vue&type=template&id=42e21972&scoped=true"
import script from "./AssessmentAndPlan.vue?vue&type=script&lang=js"
export * from "./AssessmentAndPlan.vue?vue&type=script&lang=js"
import style0 from "./AssessmentAndPlan.vue?vue&type=style&index=0&id=42e21972&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e21972",
  null
  
)

export default component.exports